import { ImosPortFunctionMapBM } from '../types/BusinessModel/ImosPortFunctionMapBM';
import { ImosPortFunctionMap } from '../types/ViewModel/ImosPortFunctionMap';

export class ImosPortFunctionMapFactory {
    constructor() {}

    public newImosPortFunctionMapArray(imosPortFuncMapBMList: ImosPortFunctionMapBM[]): ImosPortFunctionMap[] {
        const imosPortFuncMapList: ImosPortFunctionMap[] = [];
        if (imosPortFuncMapBMList && imosPortFuncMapBMList.length > 0) {
            imosPortFuncMapBMList.forEach((item) => {
                imosPortFuncMapList.push(this.createImosPortFunctionMapItem(item));
            });
        }
        return imosPortFuncMapList;
    }

    private createImosPortFunctionMapItem(item: ImosPortFunctionMapBM): ImosPortFunctionMap {
        return new ImosPortFunctionMap(item.imosPortFunctionMapId, item.eventTypeGroupId, item.imosPortFunction);
    }
}
